import { createSelector } from '@reduxjs/toolkit'
import { compact } from 'lodash'

export const sortedMessages = createSelector(
  (result, threadId) => result?.messageThreads?.[threadId]?.messages,
  (result) => result?.messages.loadedChatMessages,
  (messageIds, messages) => compact(messageIds?.map(id => messages[id])?.sort((a,b) => {
    if (a.posted_at < b.posted_at) return -1
    if (a.posted_at > b.posted_at) return 1
    return 0
  }))
)

export const messageThreadsByOwnerId = createSelector(
  (result) => result?.messageThreads,
  (result, ownerId) => ownerId,
  (threads, ownerId) => threads ? Object?.values(threads)
    ?.filter(thread => thread?.owner_id == ownerId)
    ?.sort((a,b) => {
      const aIsSeen = a.last_seen_id === a.last_message_id
      const bIsSeen = b.last_seen_id === b.last_message_id

      if (aIsSeen !== bIsSeen) {
        return aIsSeen ? 1 : -1
      }

      return new Date(b.last_message_at) - new Date(a.last_message_at)
    }) : null
)

export const selectThreadById = createSelector(
  (result) => result?.messageThreads,
  (_, threadId) => threadId,
  (threads, threadId) => threads?.[threadId]
)

export const selectMessageAuthors = createSelector(
  (result) => result?.messageThreads,
  (_, threadId) => threadId,
  (threads, threadId) => threads?.[threadId]?.message_authors
)

export const selectOwner = createSelector(
  (result) => result?.owners,
  (_, ownerId) => ownerId,
  (owners, ownerId) => owners?.[ownerId]
)

export const selectOwnerUsers = createSelector(
  (result) => result?.owners,
  (_, ownerId) => ownerId,
  (owners, ownerId) => owners?.[ownerId]?.users
)

export const selectRoles = createSelector(
  (result) => result?.owners,
  (_, ownerId) => ownerId,
  (owners, ownerId) => owners?.[ownerId]?.roles
)

export const selectLastSeenId = createSelector(
  (result) => result?.messageThreads,
  (result, threadId) => threadId,
  (threads, threadId) => threads?.[threadId]?.last_seen_id
)

export const selectFirstMessageId = createSelector(
  (result) => result?.messageThreads,
  (result, threadId) => threadId,
  (threads, threadId) => threads?.[threadId]?.first_message_id
)

export const selectLastMessageId = createSelector(
  (result) => result?.messageThreads,
  (result, threadId) => threadId,
  (threads, threadId) => threads?.[threadId]?.last_message_id
)

export const selectParticipants = createSelector(
  (result) => result?.messageThreads,
  (result, threadId) => threadId,
  (threads, threadId) => threads?.[threadId]?.participants
)

export const selectUnreadMessageCount = createSelector(
  (result) => result?.owners,
  (result, ownerId) => ownerId,
  (owners, ownerId) => owners?.[ownerId]?.unread_comments
)

  export const selectTotalPageCountForThread = createSelector(
    (result) => result?.messageThreads,
    (result, threadId) => threadId,
    (result, _, messagesPerPage) => messagesPerPage,
    (threads, threadId, messagesPerPage ) => Math.ceil(threads?.[threadId]?.total_messages / messagesPerPage) || 0
  )

// https://redux.js.org/tutorials/essentials/part-7-rtk-query-basics#rtk-query-overview
